import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveUnit } from '../../store/authSlice';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const UnitDropdown = () => {
    const units = useSelector(state => state.auth.units);
    const activeUnit = useSelector(state => state.auth.activeUnit);
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleUnitChange = (event) => {
        // Find the full unit object from units array
        const selectedUnit = units.find(unit => String(unit.UnitSerNum) === event.target.value);
        dispatch(setActiveUnit(selectedUnit));
        // Redirect to the dashboard after setting the active unit
        navigate('/dashboard');
    };
    return (
        <Box>
            <FormControl fullWidth size="small">
                <InputLabel id="unit-select-label">Customer</InputLabel>
                <Select
                    labelId="unit-select-label"
                    value={activeUnit ? String(activeUnit.UnitSerNum) : ''}
                    onChange={handleUnitChange}
                    label="Select Unit"
                >
                    {Array.isArray(units) && units.map(unit => (
                        <MenuItem
                            key={String(unit.UnitSerNum)}
                            value={String(unit.UnitSerNum)}
                        >
                            {unit.CustomerAlias ? `${unit.CustomerAlias} - ${unit.UnitID || unit.UnitSerNum}` : `${unit.FirstName} ${unit.LastName} - ${unit.UnitID || unit.UnitSerNum}`}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default UnitDropdown;